// extracted by mini-css-extract-plugin
export default {"modalOverlay":"dE-z","modalContent":"eE-z","header":"fE-z","close":"gE-z"};